import React, { Component } from "react";
import cookieManager from "../../../../utils/cookieManager";
import i18n from "../../../../i18n";
import moment from "moment/moment";
const token = cookieManager.getUserToken();

export class FormLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
  }
}

checkLabel(label){
  const labelMap = {
    idBranch: 'Branch',
    idStore: 'Store',
    idType: 'Customer Type',
    paymentType: 'Payment Type',
    idProvince: 'Province',
    code: 'Code',
    name: 'Name',
    address: 'Address',
    idCity: 'City',
    idDistrict: 'District',
    idSubDistrict: 'Sub District',
    phone: 'Phone',
    email: 'E-Mail',
    idNumber: 'ID Number',
    taxStatus: 'Tax Status',
    npwp: 'NPWP',
    contactPerson: 'Contact Person',
    contactPersonPhone: 'Contact Person Phone',
    top: 'TOP',
    creditLimit: 'Limit Credit',
    invoiceLimit: 'Invouce Limit',
    logBusiness: 'Long Business',
    longitude: 'Longitude',
    latitude: 'Latitude',
  };

  const name = labelMap[label] || ''; 
  return name;
}

render() {
    const {data}=this.props
    let arr = [];
    if(data != null && data != undefined){
      arr = data.data;
    }
    
    return (
    <div className="space-y-4">
      <h2 className="font-medium text-lg">
        {arr.code} | {arr.name_customer}
      </h2>
      {arr.change != null && arr != [] ?
        <div className="mt-3 bg-gray-50 p-3 rounded">
          <div className="space-y-6">
            {arr.change.length > 0 ?
              arr.change.map((changeItem, index) => (
                <div key={index} className="border p-4 rounded-lg shadow-sm">
                  <div className="flex items-center justify-between mb-3">
                    <h2 className="font-bold text-lg">
                      {i18n.t("Update")} {index + 1}
                    </h2>

                    <div className="flex items-center gap-4 text-sm text-gray-500">
                      <span>{moment(changeItem.date).locale('id').format('DD MMMM YYYY, HH:mm')}</span>
                      <span>{" | "}</span>
                      👤 <span className="font-medium">{changeItem.user}</span>
                    </div>
                  </div>
                    <table className="w-full text-left border-collapse" style={{fontSize:'16px'}}>
                        <thead>
                            <tr>
                                <th className="border-b p-2">{i18n.t("Data Update")}</th>
                                <th className="border-b p-2">{i18n.t("Old value")}</th>
                                <th className="border-b p-2">{i18n.t("New Value")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(changeItem.data).map(([key, value]) => (
                                <tr key={key}>
                                    <td className="border-b p-2">{this.checkLabel(key)}</td>
                                    <td className="border-b p-2">
                                        {value.old === null ? <i className="text-gray-400">{"Data Empty"}</i> : value.old}
                                    </td>
                                    <td className="border-b p-2">
                                        {value.new === "null" ? <i className="text-gray-400">{"Data Empty"}</i> : value.new}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))
            :<div className="mt-3 bg-gray-50 p-3 rounded">
        <h1 className="font-medium text-sm mb-1">{i18n.t("Log Not Found")}</h1>
      </div>}
        </div>
        </div>
      
      :null
      }
      
    </div>
  );
  }
}

export default FormLog;


